import React from 'react';

export default function FilingDetailsSummary({ summary }) {
  const summaryText = String(summary ?? '').trim();

  return (
    <div className="report-card filing-details-summary">
      <div className="report-card-title filing-details-summary__title">Summary</div>
      <div className="filing-details-summary__body">
        {summaryText ? (
          <div className="filing-details-summary__text">{summaryText}</div>
        ) : (
          <p className="filing-details-summary__empty">No summary available for this filing.</p>
        )}
      </div>
    </div>
  );
}
